import React, { useEffect, useRef, useState } from "react";
import { Form } from "antd";
import { connect } from "react-redux";
import styles from "./sendEmailToSellerForm.scss";
import EmailInput from "./EmailInput";
import MessageInput from "./MessageInput";
import AgreementSection from "./AgreementSection";
import { sendEmailToDealerAction } from "../../../../../routes/Ad/ad.ducks";
import Footer from "./Footer";
import ReactGA from "react-ga4";
import { selectCategories } from "../../../../App/selectors";
import { selectLoadedUser } from "../../../../../routes/Auth/auth.ducks";
import useHrPageName from "../../../../../utils/useHrPageName";
import { PageRoute, VerifyModalI } from "../../../../../models";
import history from "../../../../../history";
import { checkEmptyObject } from "../../../../../services";
import VerifyModal from "../../../../../components/VerifyModal";
import { getVerifyModalContent } from "../../../../../services/getVerifyModalContent";

const blankVerifyModal: VerifyModalI = {
  heading: "",
  content: "",
  redirectPath: ""
};

function EmailDealerForm(props: any) {
  const {
    form,
    onCancel,
    category,
    setVisible,
    user
  } = props;

  const [agreementChecked, setAgreementChecked] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [canSubmit, setCanSubmit] = useState(false);
  const hrPageName = useHrPageName(category);
  const [verifyModal, setVerifyModal] = useState(blankVerifyModal);

  useEffect(() => {
    setDefaultEmailField();
  }, [user]);

  useEffect(() => {
    const canSubmit = agreementChecked;
    setCanSubmit(canSubmit);
  }, [agreementChecked]);

  const setDefaultEmailField = () => {
    if (user && user.email) {
      form.setFieldsValue({
        email: user.email
      });
    }
  }

  const onAgreementChange = (allChecked: any) => {
    setAgreementChecked(allChecked);
  };

  const onSubmitFormSuccess = () => {
    const { form } = props;
    // reset fields
    setVisible(false);
    form.resetFields();
    setDefaultEmailField();
    setSubmitting(prev => !prev);
  };

  const submitForm = () => {
    const { adId, form, sendEmailToDealer } = props;

    if (checkEmptyObject(user) && user.isVerified && !user.hasInvalidUsername) {
      ReactGA.event({
        category: "Detalji oglasa",
        action: "Click",
        label: `Email pošalji - ${hrPageName}`
      });

      if (submitting) {
        return;
      }

      form.validateFields((err: any, values: any) => {
        if (!err) {
          // mark at submitting
          setSubmitting(prev => !prev);

          sendEmailToDealer({ adId, ...values }, (success: any) => {
            if (success) {
              onSubmitFormSuccess();
            } else {
              // reset submitting status
              setSubmitting(prev => !prev);
            }
          });
        }

        setTimeout(() => {
          const formItemControlWithError = document.getElementsByClassName("ant-form-item-control has-error");
          if (formItemControlWithError && formItemControlWithError.length > 0) {
            formItemControlWithError[0].scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            });
          }
        }, 500);
      });
    }
    else {
      setVerifyModal(getVerifyModalContent(user));
    }
  };

  return (
    <Form className={styles.container}>
      <EmailInput form={form} user={user} isHidden={true} />
      <MessageInput form={form} />
      <AgreementSection onChange={onAgreementChange} />
      <Footer
        submitting={submitting}
        onSubmit={submitForm}
        onCancel={onCancel}
        canSubmit={canSubmit}
      />
      <VerifyModal
        visible={verifyModal.heading !== "" && verifyModal.content !== "" && verifyModal.redirectPath !== ""}
        onOk={() => {
          history.push(verifyModal.redirectPath), setVerifyModal(blankVerifyModal);
        }}
        onCancel={() => {
          history.replace("/"), setVerifyModal(blankVerifyModal);
        }}
        onClose={() => setVerifyModal(blankVerifyModal)}
        closable={false}
        className={styles.modal}
        {...verifyModal}
      />
    </Form>
  );
}

export default connect(
  state => ({
    categories: selectCategories(state),
    user: selectLoadedUser(state),
  }),
  {
    sendEmailToDealer: sendEmailToDealerAction
  }
)(
  Form.create()(EmailDealerForm)
);



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/EmailDealerForm/index.tsx